import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class CoatingService {
    constructor(http) {
        this.http = http;
        this.singular = 'coating';
        this.plural = 'coatings';
        this.editor = PLATFORM.moduleName('pages/system-fields/coatings/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`coatings/filter/${loadOptions}`);
        return await response.json();
    }

    async create(coating) {
        await this.http.fetch('coatings', { method: 'POST', body: json(coating) });
    }

    async update(coating) {
        await this.http.fetch(`coatings/${status.id}`, { method: 'PUT', body: json(coating) });
    }

    async delete(id) {
        await this.http.fetch(`coatings/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`coatings/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`coatings/top-three/${query}`);
        return await response.json();
    }
}